import React, { Dispatch, SetStateAction } from 'react';
import { VbzButton, VbzModal, VbzCalendar, VbzInputText, VbzDropdown } from '@smiles/voebiz-ui-kit';
import { ModalBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { subjectActions, statusActions } from '../../../tests/mock/attendancesMock';
import { FilterKeys } from '../../utils/types';
import { Moment } from 'moment';

export type ModalT = {
  isOpen: boolean;
  toggle: () => void;
  setFilterValues: Dispatch<SetStateAction<FilterKeys>>;
  modalFilterValues: FilterKeys;
  setModalFilterValues: Dispatch<SetStateAction<FilterKeys>>;
};

export function ModalFilters(props: ModalT) {
  const { t } = useTranslation('list_attendance');
  const isButtonDisabled = Object.keys(props.modalFilterValues).length === 0;

  const handleOnClick = () => {
    props.setFilterValues(props.modalFilterValues);
    props.toggle();
  };

  const handleChangeCalendar = (dates: {startDate: Moment | null; endDate: Moment | null}) => {
    if(dates.startDate)
      props.setModalFilterValues({ ...props.modalFilterValues, date: dates.startDate.format() });
  }

  return (
    <VbzModal isOpen={props.isOpen} toggle={props.toggle} data-testid="vbz-modal-filters">
      <ModalBody>
        <h4 className="vbz-list-attendance-modal__title">{t('filterTitle')}</h4>
        <div>
          <div className="vbz-list-attendance-modal__fieldset">
            <div className="vbz-list-attendance-modal__fieldset__label">
              <span> {t('selectDateLabel')} </span>
            </div>
            <VbzCalendar
              id="calendar"
              startDateId="startDateId"
              endDateId="endDateId"
              onChange={handleChangeCalendar}
              numberOfMonths={1}
              startDatePlaceholderText={t('selectDatePlaceholder')}
              singleDateTitleHeader={t('selectDatePlaceholder')}
              isSingleDate
              numberOfVerticalMonths={6}
              startDateInitialValue={props.modalFilterValues.date}
            />
          </div>
          <div className="vbz-list-attendance-modal__fieldset">
            <div className="vbz-list-attendance-modal__fieldset__label">
              <span className="vbz-list-attendance-modal__fieldset__label"> {t('inputAttendanceNumberLabel')} </span>
            </div>

            <VbzInputText
              value={props.modalFilterValues.number}
              placeholder={t('inputAttendanceNumberPlaceholder')}
              onChange={(e) =>
                props.setModalFilterValues((prev) => {
                  return { ...prev, number: e.target.value };
                })
              }
            />
          </div>
          <div className="vbz-list-attendance-modal__fieldset">
            <div className="vbz-list-attendance-modal__fieldset__label">
              <span className="vbz-list-attendance-modal__fieldset__label"> {t('selectSubjectLabel')} </span>
            </div>

            <VbzDropdown
              errorMessage=""
              actions={subjectActions}
              placeholder={t('selectSubjectPlaceholder')}
              value={props.modalFilterValues.subject}
              onClick={(name) =>
                props.setModalFilterValues((prev) => {
                  return { ...prev, subject: name };
                })
              }
            />
          </div>
          <div className="vbz-list-attendance-modal__fieldset">
            <div className="vbz-list-attendance-modal__fieldset__label">
              <span className="vbz-list-attendance-modal__fieldset__label"> {t('selectStatusLabel')} </span>
            </div>

            <VbzDropdown
              errorMessage=""
              actions={statusActions}
              placeholder={t('selectStatusPlaceholder')}
              value={props.modalFilterValues.status}
              onClick={(name) =>
                props.setModalFilterValues((prev) => {
                  return { ...prev, status: name };
                })
              }
            />
          </div>
          <VbzButton text={t('filter')} onClick={handleOnClick} disabled={isButtonDisabled} />
        </div>
      </ModalBody>
    </VbzModal>
  );
}
